import React from "react";

function CopyrightModel() {
    return (
        <div className="info-detail">
            <p className="info-title">사용 모델</p>
            <p className="info-item">요약 모델</p>
            <p className="info-item-item">- gogamza/kobart-summarization</p>
            <p className="info-item">키워드</p>
            <p className="info-item-item">- skt/kobert-base-v1</p>
            <p className="info-item">감성분석</p>
            <p className="info-item-item">- snunlp/KR-FinBert-SC</p>
            <p className="info-item">불용어</p>
            <p className="info-item-item">- https://raw.githubusercontent.com/stopwords-iso/stopwords-ko/master/stopwords-ko.txt</p>
            <p className="info-item">기업명 추출</p>
            <p className="info-item-item">- Gemini</p>
            <p className="info-item">폰트</p>
            <p className="info-item-item">- 인천교육힘찬체 인천 정예림 교원 손글씨로 제작</p>
            <p className="info-item">로고 제작</p>
            <p className="info-item-item">- Canba</p>

        </div>
    );
}

export default CopyrightModel;
